import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { ApplicationConfigService } from 'services/application-config.service';
import { IBasket } from '../models/basket.model';
import { Transport } from '../models/transport.model';
import { BasketOrder } from '../models/basket-order.model';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { map } from 'rxjs/operators';
import { ApiProviderService } from './api-provider.service';
import { createRequestOption, mapAsBody } from '../app/shared/util/request-util';
import { AddToBasket } from '../models/add-to-basket.model';
import { CurrentUserBasket } from '../models/current-user-basket.model';

@Injectable({ providedIn: 'root' })
export class BasketService {
  protected basketTransportIdUrl = API_ENDPOINTS.BASKET_TRANSPORT_ID;

  constructor(protected http: HttpClient, protected apiProvider: ApiProviderService, protected applicationConfigService: ApplicationConfigService) {}

  public addTransportToBasket(transport: Transport): Observable<AddToBasket> {
    if (transport) {
      return this.apiProvider.post<AddToBasket>(API_ENDPOINTS.BASKET_TRANSPORT, transport.serialize()).pipe(mapAsBody);
    }
    return of();
  }

  public updateTransportInBasket(transport: Transport): Observable<AddToBasket> {
    return this.apiProvider.put<AddToBasket>(this.basketTransportIdUrl(transport.id), transport.serialize()).pipe(mapAsBody);
  }

  public removeTransportInBasket(transport: Transport): Observable<void> {
    return this.apiProvider.delete(this.basketTransportIdUrl(transport.id)).pipe(map(() => undefined));
  }

  public getBasket(): Observable<CurrentUserBasket> {
    return this.apiProvider
      .get<CurrentUserBasket>(API_ENDPOINTS.BASKET)
      .pipe(mapAsBody)
      .pipe(map((res: any) => new CurrentUserBasket(res)));
  }

  public processBasketPayment(): Observable<BasketOrder> {
    return this.apiProvider.post<BasketOrder>(API_ENDPOINTS.BASKET_PROCEED_PAYMENT, null).pipe(map(httpResponse => httpResponse.body!));
  }

  public hasBasketChanges(basket?: CurrentUserBasket, onlineBasket?: CurrentUserBasket): boolean {
    return basket?.price !== onlineBasket?.price;
  }

  public query(req?: any): Observable<HttpResponse<IBasket[]>> {
    const options = createRequestOption(req);
    return this.apiProvider.get<IBasket[]>(API_ENDPOINTS.BASKET, { params: options, observe: 'response' });
  }
}
